module.exports = __webpack_public_path__ + "img/wulianwang.2c7df985.png";